<template>
  <div>
    <page-main
      :tableData="tableData"
      :loading="loading"
      :tablePage="page"
      @reload="reload"
      ref="main"
    >
      <page-header
        ref="header"
        slot="header"
        @query="getData"
        @reset="resetPage"
        @confirmChange="confirmChange"
      />
      <pagination
        size="small"
        align="right"
        slot="pager"
        :current-page="page.curPage"
        :page-size="page.pageSize"
        :page-total="page.pageTotal"
        @change="handlePaginationChange"
      />
    </page-main>
  </div>
</template>
<script>
import PageMain from './main'
import PageHeader from './header'
import BaseTable from '@/mixins/base-table'
export default {
  components: {
    PageHeader,
    PageMain
  },
  mixins: [BaseTable],
  data() {
    return {
      usePage: true
    }
  },
  methods: {
    getData(form) {
      this.loading = true
      this.$api
        .orderDashboardListApi({
          ...form,
          ...this.page
        })
        .then((res) => {
          this.loading = false
          this.setData(res)
        })
        .catch(() => {
          this.loading = false
        })
    },
    async confirmChange(params) {
      const data = await this.$refs.main.getCheckboxRecords()
      if (data.length <= 0 || data === undefined) return
      const orderCodeList = [] 
      data.forEach((item) => {
          orderCodeList.push(item.orderCode)
      })

      const loadingInstance = this.$loading({
        lock: true,
        text: 'Loading',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)',
      })
      let apiResponse
      if (params.type === 'changeSales'){
        apiResponse = this.$api
        .orderInfoChangeSalesApi({orderCodeList:orderCodeList,salesPersonCode:params.userCode,salesPersonName:params.userName})
      }else{
          apiResponse = this.$api
        .orderInfoChangeBizApi({orderCodeList:orderCodeList,bizPersonCode:params.userCode,bizPersonName:params.userName})
      }
      apiResponse
        .then((res) => {
          loadingInstance.close()
          this.$message({
            showClose: true,
            message: res.msg,
            type: 'success',
          })
          this.$refs.main.clearCheckBoxRow()
          this.reload()
        })
        .catch(() => {
          loadingInstance.close()
        })
    },
  }
}
</script>
